<template>
  <div>
    <input type="file"
           accept="video/*,video/x-flv"
           :name="inputName"
           class="upload-video"
           style="display: none"
           @change="upload">
    <input type="text" name="video_name" style="display: none" :value="name">
    <button :disabled="disabled" type="button" @click.prevent="onClickButtonUpload">Upload Video</button>
    <strong v-show="isUploading" class="loading">Uploading</strong>
    <span class="text-danger"><strong>{{ error }}</strong></span>
    <strong v-show="!isUploading" class="video-name">{{ videoName }}</strong>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
    },

    inputName: {
      type: String,
      default() {
        return 'file';
      }
    },

    name: {
      type: String,
    },

    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
    
  data() {
    return {
      isUploading: false,

      error: '',

      videoName: this.name ? this.name : '',
    };
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$on('refreshVideo', () => {
        //todo update video name correct
        this.videoName = this.name;
      });
    },

    onClickButtonUpload() {
      $(this.$el.firstElementChild).click();
    },
      
    upload() {
      let video = this.$el.firstElementChild.files[0];

      if (!video.type.match('video.*')) {
        this.clearFiles();

        return;
      }

      if (! this.isValidSize(video)) {
        this.clearFiles();

        this.videoName = '';

        let maxVideoSizeMb,
          response = {};

        maxVideoSizeMb = this.getMaxSize();
        response = {
          data: {
            error: `This video exceeds the maximum file size of ${maxVideoSizeMb}mb.`
          }
        };

        this.setError(response);

        return;
      }

      this.clearError();

      this.isUploading = true;

      let formData = new FormData();
        
      formData.append('video', video);
        
      axios.post(this.url, formData,
        {
          headers: {'content-type': 'multipart/form-data'}
        })
        .then((response) => {
          this.isUploading = false;

          this.$emit('input', response.data);

          this.videoName = video.name;

          this.clearFiles();
        })
        .catch((error) => {
          this.isUploading = false;

          this.videoName = '';

          this.setError(error.response);

          this.clearFiles();
        });
    },
      
    clearFiles() {
      this.$el.firstElementChild.value = "";
    },

    clearError() {
      this.error = '';
    },

    isValidSize(video) {
      let sizeMb = video.size / (1000 * 1000),
        maxVideoSizeMb = this.getMaxSize();

      return sizeMb < maxVideoSizeMb;
    },

    setError(response) {
      if (response.status === 413) {
        let maxVideoSizeMb = this.getMaxSize();

        this.error = `This video exceeds the maximum file size of ${maxVideoSizeMb}mb.`;

        return;
      }

      if (response.data.error) {
        this.error = response.data.error;

        return;
      }

      this.error = response.data.errors.video[0];
    },

    getMaxSize() {
      let maxVideoSizeMb = document.head.querySelector('meta[name="video-max-size-mb"]');

      return  maxVideoSizeMb ? maxVideoSizeMb.content : 100;
    }
  }
};
</script>
